import { createContext, useContext } from 'react';

export const WorkflowTrackerDownloadsContext = createContext<
  ((trackerId: string, sourceDocumentId: string) => void) | undefined
>(undefined);

export function useAwaitTrackerDownload() {
  const context = useContext(WorkflowTrackerDownloadsContext);
  if (!context) {
    throw new Error(
      'Workflow tracker downloads require the current user tracker provider'
    );
  }
  return context;
}
